import { fetchAuthSession } from 'aws-amplify/auth';
import { AuthUser } from '../types';
import { useProductStore } from '../store/productStore';
import { useReceiptStore } from '../store/receiptStore';
import { useTrackingStore } from '../store/trackingStore';
import { useAppStore } from '../store/appStore';
import { SCREEN_TYPES } from './constants';
import { useArrivalReceiptStore } from 'store/arrivalReceiptStore';

export const getSessionUser = async (): Promise<AuthUser> => {
  const session = await fetchAuthSession();
  const idToken = session.tokens?.idToken;

  if (!idToken) {
    throw new Error('No valid session found');
  }

  const payload = idToken.payload as Record<string, unknown>;

  const user = {
    email: payload.email as string,
    name: payload.name as string,
    sub: payload.sub as string,
    id: payload.sub as string,
  };

  return user;
};

export const resetAllProductRelatedStores = () => {
  useProductStore.getState().reset();
  useReceiptStore.getState().reset();
  useTrackingStore.getState().reset();
  useArrivalReceiptStore.getState().reset();
};

export const handleScanItemPageOpened = () =>
  useAppStore.getState().setCurrentScreen(SCREEN_TYPES.SCAN_ITEM);
export const handleCloseReceipt = () =>
  useAppStore.getState().setCurrentScreen(SCREEN_TYPES.CONFIRM_CLOSE);
